<template>
  <div class="esport-page-container">
    <div class="club-info-box" v-if="curClub">
      <div class="left-club-info">
        <div class="club-name">
          <AutoTitle textAlign="center">{{ curClub.name }}</AutoTitle>
        </div>
        <div
          class="club-logo"
          :style="{
            backgroundImage: `url(${curClub.logo})`,
          }"
        ></div>
        <div class="club-twitter" @click="gotoTwitter(curClub)"></div>
        <div class="club-join-time">
          {{ curClub.joinTime | formatDate("YYYY/MM/DD") }}
        </div>
      </div>
      <div class="middle-info-box">
        <div class="tab-switch-list">
          <div
            class="tab-item"
            :class="{ active: activeTabKey == tab.key }"
            v-for="tab in tabList"
            :key="tab.key"
            @click="activeTabKey = tab.key"
          >
            <span>{{ tab.name }}</span>
          </div>
        </div>
        <div class="tab-container">
          <div class="club-introduce" v-if="activeTabKey == 'introduce'">
            <div class="introduce-title">
              <div class="title-box">
                <span>{{ getPageDict(13) /* 简介 */ }}:</span>
              </div>
            </div>
            <preDiv class="introduce-desc" :text="curClub.introduce" />
            <div class="introduce-title">
              <div class="title-box">
                <span>{{ getPageDict(14) /* 主要成就 */ }}:</span>
              </div>
            </div>
            <preDiv class="introduce-desc" :text="curClub.achievement" />
          </div>
          <lrSlideBox
            class="club-player"
            v-if="activeTabKey == 'player'"
            key="player"
          >
            <div class="player-list">
              <div
                class="player-item"
                v-for="(player, index) in curClub.players"
                :key="index"
                :style="{
                  backgroundImage: `url(${player.img})`,
                }"
              >
                <div class="player-job">{{ player.job }}</div>
                <div class="player-name">{{ player.name }}</div>
              </div>
            </div>
          </lrSlideBox>
          <lrSlideBox
            class="club-match"
            v-if="activeTabKey == 'match'"
            key="match"
          >
            <div class="match-list">
              <div
                class="match-item"
                v-for="(match, index) in curClub.matchs"
                :key="index"
              >
                <div class="match-time">{{ match.matchInfo.matchMonth }}月</div>
                <div
                  class="match-logo"
                  :style="{
                    backgroundImage: `url(${match.matchInfo.logo})`,
                  }"
                ></div>
                <div class="match-name">
                  <AutoTitle textAlign="center">{{
                    match.matchInfo.name
                  }}</AutoTitle>
                </div>
                <div class="match-rank">
                  <span v-if="match.rank">{{
                    getPageDict(17, [match.rank]) /* 第1名 */
                  }}</span>
                  <span v-else class="playing">{{
                    getPageDict(15) /* 参战中 */
                  }}</span>
                </div>
                <div class="watch-match-btn" @click="gotoWatchMatch(match)">
                  {{ getPageDict(16) /* 观战 */ }}
                </div>
              </div>
            </div>
          </lrSlideBox>
          <!-- <div class="club-player"></div> -->
        </div>
        <div class="bottom-splint-box"></div>
      </div>
    </div>
    <clubNav />
  </div>
</template>

<script>
import {
  getDict,
  getPageDictInit,
  axios,
  formatDate,
  getPageLevelMixin,
  invokeNative,
} from "@/common";
import { mapState, mapGetters } from "vuex";
import store from "@/store";
import AutoTitle from "@/components/autoTitle";
import preDiv from "@/components/preDiv";
import lrSlideBox from "../../comps/lr-slide-box";
import clubNav from "../../comps/clubNav";

const getPageDict = getPageDictInit("eSport");

export default {
  name: "eSportClubPage",
  // mixins: [getPageLevelMixin],
  components: {
    AutoTitle,
    preDiv,
    lrSlideBox,
    clubNav,
  },
  props: {},
  data() {
    return {
      tabList: [
        {
          key: "introduce",
          name: getPageDict(9) /* "介绍" */,
        },
        {
          key: "player",
          name: getPageDict(10) /* "选手" */,
        },
        {
          key: "match",
          name: getPageDict(11) /* "大会" */,
        },
      ],
      activeTabKey: "introduce",
    };
  },
  computed: {
    ...mapState({
      clubList: (state) => state.clubPage.clubList,
    }),
    ...mapGetters({
      curClub: "clubPage/curClub",
    }),
  },
  watch: {},
  methods: {
    getDict,
    getPageDict,
    gotoTwitter(club) {
      if (!club.clubTwitter) {
        return;
      }
      invokeNative(
        "goToTwitter",
        {
          url: club.clubTwitter,
        },
        (res) => {
          // 执行成功
        },
        (res) => {
          //执行失败
        }
      );
    },
    gotoWatchMatch(item) {
      // debugger
      this.$router.push({
        name: "videoList",
        params: { collectionId: item.matchInfo.collectionId },
      });
    },
  },

  mounted() {},
  created() {
    store.dispatch("clubPage/getClubListWhileNeed");
  },
};
</script>

  <style lang="scss" scoped>
.esport-page-container {
  height: 0;
  flex: 1;
  margin-top: 0.12rem;
  display: flex;

  .club-info-box {
    flex: 1;
    display: flex;
    margin-right: 0.15rem;

    .left-club-info {
      width: 2.77rem;
      height: 4.66rem;
      background: url(../../imgs/club-left-box-bg.png) no-repeat;
      background-size: 100% auto;
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;

      .club-name {
        display: inline-block;
        font-size: 0.3rem;
        color: #fefefe;
        padding: 0.1rem 0;
        margin: 0 10%;
        width: 100%;

        border-bottom: 0.02rem solid;
        $border-color: #ffd8a4;
        border-image: linear-gradient(
          to right,
          rgba($border-color, 0),
          rgba($border-color, 1),
          rgba($border-color, 0)
        );
        border-image-slice: 0 0 100% 0;
      }
      .club-logo {
        display: inline-block;
        $size: 2.42rem;
        width: $size;
        height: $size;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center center;
        margin-top: 0.1rem;
        // background-color: #fff;
      }
      .club-twitter {
        display: inline-block;
        width: 1.55rem;
        height: 0.43rem;
        background-repeat: no-repeat;
        background-image: url(../../imgs/twitter-btn.png);
        background-position: center;
        background-size: contain;
        margin-top: 0.1rem;
      }
      .club-join-time {
        display: inline-block;
        height: 0.32rem;
        width: auto;
        // max-width: 100%;
        padding: 0 0.2rem;
        line-height: 0.32rem;
        $bg-color: #f9d567;
        background-image: linear-gradient(
          to right,
          rgba($bg-color, 0) 0%,
          rgba($bg-color, 1) 30%,
          rgba($bg-color, 1) 70%,
          rgba($bg-color, 0) 100%
        );
        margin-top: 0.1rem;
        color: #29282a;
        font-size: 0.2rem;
      }
    }
    .middle-info-box {
      margin-left: 0.15rem;
      flex: 1;
      width: 0;
      display: flex;
      flex-direction: column;
      .tab-switch-list {
        display: flex;
        .tab-item {
          flex: 1;
          // width: 2.01rem;
          height: 0.7rem;
          flex-shrink: 0;
          font-size: 0.24rem;
          font-weight: 600;
          display: flex;
          justify-content: center;
          align-items: center;
          // background: url(./imgs/nav-item.png);
          // background-image: url(../../imgs/tab-nav.png);
          background-image: url(../../imgs/tab-switch-btn-bg.png);
          background-size: 100% 100%;
          &:not(:first-child) {
            border-left: 0.01rem solid #ffeb78;
          }

          span {
            background-image: -webkit-linear-gradient(bottom, #f39b25, #a76002);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }

          &.active {
            // background-image: url(./imgs/nav-item-active.png);
            // background-image: url(../../imgs/tab-nav-active.png);
            background-image: url(../../imgs/tab-switch-btn-bg-active.png);
            span {
              background-color: #292829;
              background-image: none;
            }
          }
        }
      }
      .tab-container {
        flex: 1;
        height: 0;
        background-color: rgba(#fff, 0.3);
        display: flex;
        flex-direction: column;
        .club-introduce {
          flex: 1;
          height: 0;
          // height: 100%;
          overflow: auto;
          color: #383738;
          $introduce-padding: 0.25rem;
          .introduce-title {
            $font-size: 0.24rem;
            $height: 0.34rem;

            height: $height;
            padding-left: $introduce-padding;

            $decorate-color: #ffa42b;
            border-left: $decorate-color solid 0.03rem;
            $decorate-height: 0.06rem;
            display: flex;
            align-items: center;
            &:first-child {
              margin-top: 0.15rem;
            }

            .title-box {
              position: relative;
              display: inline-block;
              height: $font-size;
              line-height: $font-size;
              font-size: $font-size;
              font-weight: 600;
              padding-left: 0.15rem;
              padding-right: 0.4rem;
              span {
                position: relative;
                z-index: 5;
              }
              &::before,
              &::after {
                content: "";
                position: absolute;
                left: 0;
                display: inline-block;
                height: $decorate-height;
              }
              &::before {
                top: 0;
                box-sizing: border-box;
                border: $decorate-height/2 solid;
                border-color: rgba($decorate-color, 1) rgba($decorate-color, 0)
                  rgba($decorate-color, 0) rgba($decorate-color, 1);
              }
              &::after {
                bottom: 0;
                width: 100%;
                background-image: linear-gradient(
                  to right,
                  rgba($decorate-color, 1),
                  rgba($decorate-color, 0)
                );
              }
            }
          }
          .introduce-desc {
            padding: 0.1rem $introduce-padding 0.15rem;
            font-size: 0.2rem;
            width: 100%;
          }
        }
        .club-player,
        .club-match {
          flex: 1;
          height: 0;
          // height: 100%;
          .player-list,
          .match-list {
            // border: 2px solid #f00;
            display: flex;
            .player-item,
            .match-item {
              flex-shrink: 0;
              width: 1.57rem;
              height: 2.84rem;
              display: flex;
              flex-direction: column;
              &:not(:first-child) {
                margin-left: 0.1rem;
              }
            }
            .match-item {
              background-color: rgba(#515151, 0.1);
              align-items: center;
              .match-time {
                height: 0.37rem;
                width: 100%;
                line-height: 0.37rem;
                text-align: center;
                font-size: 0.22rem;
                font-weight: 600;
                color: #fff;
                $bg-color: #ffb951;
                background-image: linear-gradient(
                  to right,
                  rgba($bg-color, 1) 50%,
                  rgba($bg-color, 0) 95%
                );
              }
              .match-logo {
                margin: 0.1rem;
                // width: 1.34rem;
                height: 1rem;
                width: 100%;
                background-size: contain;
                background-position: center;
                background-repeat: no-repeat;
              }
              .match-name {
                text-align: center;
                font-size: 0.22rem;
                color: #29282a;
              }
              .match-rank {
                text-align: center;
                font-size: 0.2rem;
                color: #29282a;
                .playing {
                  color: #f8bd4f;
                  text-shadow: 0rem -0.01rem#faef5c,
                    0.01rem 0.01rem 0.01rem#db9b04;
                }
              }
              .watch-match-btn {
                width: 0.92rem;
                height: 0.32rem;
                line-height: 0.32rem;
                text-align: center;
                color: #fff;
                font-size: 0.18rem;
                background: url(../../imgs/view-match-btn.png) no-repeat;
                background-position: center;
                background-size: contain;
                margin-top: 0.2rem;
              }
            }
            .player-item {
              //============
              background-size: cover;
              background-position: center;

              //

              justify-content: flex-end;
              .player-job {
                width: 100%;
                height: 0.29rem;
                line-height: 0.29rem;
                color: #fff;
                text-align: center;
                font-size: 0.15rem;

                background-color: rgba(0, 0, 0, 0.6);
              }
              .player-name {
                width: 100%;
                height: 0.5rem;
                line-height: 0.5rem;
                color: #fff;
                text-align: center;
                font-size: 0.15rem;

                background-image: url(../../imgs/item-foot-box-bg.png);
                background-size: cover;
              }
            }
          }
        }
      }
    }
  }
}
.bottom-splint-box {
  $margin-bottom: 0.08rem;
  width: 100%;
  height: $margin-bottom;
  display: flex;
  align-items: flex-end;
  &::before {
    content: "";
    flex: 1;
    height: 0.04rem;
    border-bottom: 0.01rem solid rgba(#fff, 0.4);
    margin-right: 0.04rem;
  }
  &::after {
    content: "";
    width: 0.34rem;
    height: 0.04rem;
    background-image: url(../../imgs/box-bottom-splint.png);
    background-size: 100% 100%;
  }
}
</style>
